import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

import { Search as SearchIcon } from '@mui/icons-material';
import { Theme } from '../Theme';
import { InputAdornment } from '@mui/material';
import { TextField } from '../Input';

export const SearchContainer = styled.div`
	display: flex;
	flex-direction: row;
	width: 100%;
	max-width: 360px;
`;

export const SearchBar = styled(TextField)`
	height: 2rem !important;
	width: 100% !important;
	background: ${Theme.lightWhite} !important;
	font-size: 12px !important;

	& .MuiInputBase-input {
		padding-left: 0 !important;
		background: ${Theme.lightWhite} !important;

		::placeholder,
		::-webkit-input-placeholder {
			font-size: 12px !important;
		}
	}
`;

export const Search = ({ searchText, placeholder, enableDelayOnChange = false, delay = 0, onSearchHandler = null, searchOnChange = false, style = {}, ...props }) => {
	const [searchTimeout, setSearchTimeout] = useState(null);
	const [text, setText] = useState('');

	useEffect(() => {
		setText(searchText);
	}, [searchText]);

	useEffect(() => {
		if(searchOnChange){
			clearTimeout(searchTimeout);
			let timeout = onSearchHandler
				? setTimeout(
						() => {
							onSearchHandler(text);
						},
						enableDelayOnChange ? (delay ? delay : 1000) : 0
				)
				: null;
			setSearchTimeout(timeout);
		}
	}, [text]);

	const handleText = (text) => {
		setText(text);
	};

	return (
		<SearchContainer style={style}>
			<SearchBar
				primary
				name='search-bar'
				value={text}
				placeholder={placeholder}
				onChange={(e) => {
					handleText(e.target.value);
				}}
				onKeyDown={(e) => {
					if (e.key === 'Enter') onSearchHandler(text);
				}}
				startAdornment={
					<InputAdornment
						position='start'
						style={{ padding: '0' }}
					>
						<SearchIcon style={{ fontSize: '16px', color: Theme.primary, paddingLeft: '0.5rem' }} />
					</InputAdornment>
				}
			/>
		</SearchContainer>
	);
};
